import React, { Fragment } from 'react';

import { getCreditWalletInfo } from '../components/globals';
import { Languages } from './languages';

export class CreditBoxWidget extends React.Component {

    constructor(props) {
        /*
         * navigateTo
         * showExpiration (def true)
         * orderTotal
         * onWalletInfo
         */ 
        super(props);
        this.loadCreditWalletInfo = this.loadCreditWalletInfo.bind(this);
        this.uc = JSON.parse(sessionStorage.getItem("userContext"));
        this.state = {
            creditInfo: { total: 'n/d', expiringWhen:'' }            
        };
    }
    componentDidMount() {

      

        this.loadCreditWalletInfo();


    }
    componentWillReceiveProps(props) {
        const { orderTotal } = this.props;
        if (props.orderTotal !== orderTotal) {
            this.loadCreditWalletInfo();
        }
    }
    loadCreditWalletInfo() {
        try {

            getCreditWalletInfo(this.uc.jwtToken, data => {

                this.setState({ creditInfo: data.wallet });

                if (this.props.onWalletInfo)
                    this.props.onWalletInfo(data.wallet);

            },
                ko => {

                }, this);

        }
        catch (e) {

        }

    }
    render() {
        if (this.uc.userProfile && this.uc.userProfile.hasCreditBox && this.state.creditInfo) {
            let le = Languages.getSection('CreditBox');

            let orderTotal = null;
            if (this.props.hasOwnProperty("orderTotal") && this.props.orderTotal != null && this.props.orderTotal != "" && this.props.orderTotal != "0" && this.props.orderTotal != "0.00") {
                orderTotal = <div>
                    <div className="total-label">{le.credits.total}</div><div className="total-value">{this.props.orderTotal}</div>
                </div>;
            }

            let expiration = null;
            if (this.props.showExpiration == null || this.props.showExpiration == true)
                expiration = <div>
                    <div className="expiration-label">{le.credits.expiration}</div><div className="expiration-value">{this.state.creditInfo.expiringWhen || ''}</div>
                </div>;

            let buy = null;
            if (this.props.navigateTo) {
                buy = <div className="credits-widget-buy" onClick={() => this.props.navigateTo("CREDITBOXMANAGE")}>{le.credits.btn}</div>;
            }

            return <div className="credits-widget">
                <div className="credits-widget-info">
                    <div>
                        <div className="credits-label">{le.credits.label}</div><div className="credits-value">{this.state.creditInfo.total}</div>
                    </div>
                    {expiration}
                    {orderTotal}
                </div>
                {buy}

            </div>;
        }


        return null;




        /*return (
            <div className="col credit-box-widg">
                <h3><span className="bold">Crediti</span></h3>
                <h4><span className="bold">Disponibili</span><span> {this.state.creditInfo.total}</span></h4>
                <h4><span className="bold">In scadenza</span><span> {this.state.creditInfo.expiringWhen!=""?this.state.creditInfo.expiringWhen:"n/d"}</span></h4>
                {orderTotal}
                <UButton text="Acquista" onClick={this.onClick}></UButton>
            </div>

        );*/


    }
    
}